<template>
 <a-modal :title="rowList.BaseInformation.name" :visible="permissinonVisible" @cancel="closeVoisible" width="50%">
     <div class="container-center">
         限制部门：
            <a-tree checkable :autoExpandParent="autoExpandParent" v-model="checkedKeys2" checkStrictly
			 :treeData="deptTree2" @check="onCheck2">
		    </a-tree>

     </div>
     <div class="container-bottom">
         限制角色：
        <a-select style="width: 80%" mode="multiple" v-model="roleIds"
            :allowClear="true" show-search :filter-option="filterOption">
            <a-select-option v-for="(action) in roleAll" :key="action.roleId">{{ action.roleName }}</a-select-option>
        </a-select>
     </div>
    <template slot="footer">
         <a-button key="back" @click="closeVoisible">取消</a-button>
         <a-button type="primary" @click="addPermission">确定</a-button>
    </template>
 </a-modal>
  
</template>

<script>
import {getDeptList, getRoleAll, insertLimitInfo, findLimitInfo} from '@/api/system'
export default {
    data() {
        return {
            permissinonVisible: false,
            rowList: {},
            autoExpandParent: true,
            checkedKeys2: [],
            deptTree2: [],
            roleIds: [],
            roleAll: [],

        }
    },
    methods: {
        //全选
        allSelect() {
            console.log(this.deptTree2, 'deptTree2================')
            var ids = []
            this.deptTree2.forEach(item => {
                ids.push(item.value)
                if(item.children) {
                    item.children.forEach(item2 => {
                        ids.push(item2.value)
                        if(item2.children) {
                            item2.children.forEach(item3 => {
                                ids.push(item3.value)
                            })
                        }
                    })
                }

            })
            this.checkedKeys2 = ids

        },
        //清楚全部
        clearSelect() {
            this.checkedKeys2 = []
        },
        closeVoisible() {
            this.checkedKeys2 = []
            this.roleIds = []
            this.permissinonVisible = false

        },
        //提交
        addPermission() {
            var list = []
            list.push(this.rowList.BaseInformation.processKey)
            insertLimitInfo({
                processKeyList: list,
                deptIdList: this.checkedKeys2,
                roleIdList: this.roleIds,
            }).then(res => {
                if(res.code == 200) {
                    this.checkedKeys2 = []
                    this.roleIds = []
                    this.permissinonVisible = false
                    this.$message.success(res.msg)
                }else {
                    this.$message.error(res.msg)
                }

            })
        },
        init(data) {
            this.deptTree2 = []
            this.roleAll = []
            // console.log(data, 'data=================')
            getDeptList().then(res => {
				const data = res.rows
				if (data.length > 0) {
					const pids = data.map(m => m.parentId)
					this.buildtree(data, this.deptTree2, Math.min(...pids))
					// const pidSet = new Set(pids.map(m => m + ''))
					// this.pidSet = pidSet
					// this.pidSet2 = pidSet
				}
				

			})
            this.loadRoleAll()
            this.rowList = data
            this.searchData()
            this.permissinonVisible = true
        },
        searchData() {
            findLimitInfo({
                processKey: this.rowList.BaseInformation.processKey
            }).then(res => {
                if(res.code == 200) {
                    this.checkedKeys2 = res.data.deptIdList
                    this.roleIds = res.data.roleIdList
                } else {
                    this.$message.error(res.msg)
                }

            })

        },
        loadRoleAll() {
				getRoleAll().then(res => {
					this.roleAll = res.rows
				})
			},
        filterOption(input, option) {
            return (
                option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            );
        },
        buildtree(list, arr, parentId) {
            list.forEach((item) => {
                if (item.parentId === parentId) {
                    var child = {
                        key: item.deptId,
                        value: item.deptId, // value是给modal的select用的，2者属性不一样
                        title: item.deptName,
                        scopedSlots: {
                            title: 'title',
                        },
                        children: [],
                    }
                    this.buildtree(list, child.children, item.deptId)
                    if (child.children.length === 0) {
                        delete child.children
                    }
                    arr.push(child)
                }
            })
        },
        //选择权限
        onCheck2(checkedKeys, info) {
            console.log(checkedKeys, '=================================')
            // console.log('onCheck', info)
            // if (!this.treeCheck2) this.treeCheck2 = true
            this.checkedKeys2 = checkedKeys.checked
        },
    }

}
</script>

<style lang="less" scoped>
.container-top {
    display: flex;
    justify-content: space-between;

}
.container-center {
    margin: 10px 0;
}

</style>